var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nothing_order_list"},[_c('img',{attrs:{"src":"https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/nothing_red.png","alt":""}}),_vm._v(" "),_c('div',[_vm._v("订单空空如也，赶快挑选合适的商品吧！")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd5d66c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/noOrderList.vue
// module id = 6m5C
// module chunks = 44